<ng-container>
  <div class="modal-header d-print-none">
    Print Preview
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dismiss()">
    </button>
  </div>
  <div class="modal-body" *ngFor="let invoice of  pagedItems">
    <section class="row">
      <small>List of printers</small>
      <div class="col-md-7 align-items-center mb-2">
        <!-- <select class="form-select form-select-sm w-auto me-2" [(ngModel)]="selectedPrinter"> -->
          @for (printer of printers; track $index) {
          <button 
          class="btn btn-sm"
          [class.btn-primary]="selectedPrinter === printer.name"
          [class.btn-outline-secondary]="selectedPrinter !== printer.name"
          (click)="selectedPrinter = printer.name">
          {{ printer.displayName || printer.name }}
        </button>
        }
        <!-- </select> -->

        <!-- 🧾 Print Invoice -->
        <button class="btn btn-success btn-sm" id="printBtn" (click)="printSelectedInvoice([invoice])">
          Print
        </button>
      </div>

      <div class="col-md-5">
        {{'Invoice'|translate}} :&nbsp;{{invoice?.invoiceNumber}}
        <a button style="margin-top:0px" class="pull-right social-button shape-rounded sb-digg"
          href="javascript:void(0);" data-bs-toggle="tooltip" title="Print Current Invoice"
          container="ngb-modal-window">
          <i class="material-icons print " (click)="printInvoice([invoice])"></i>
        </a>
      </div>
    </section>
    <div #invoiceTemplate>
    <section class="row">
      <div class="col-md-7">
        {{'Vazipadu'|translate}} :&nbsp;{{invoice?.poojaName}}
      </div>
      <div class="col-md-5">
        {{'Date'|translate}} :&nbsp;&nbsp;&nbsp; {{invoice?.billDate}}
      </div>
    </section>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>{{'Devotee'|translate}} {{'Name'|translate}}</th>
          <th>{{'Devotee'|translate}} {{'Star'|translate}}</th>
          <th>{{'Amount'|translate}}</th>
        </tr>
      </thead>
      <tbody>

        <tr *ngFor="let devotee of invoice?.devoteeDetailList,let i=index;">
          <td>
            {{devotee.devoteeName ? devotee.devoteeName:'-'}}
          </td>
          <td>
            {{devotee.devoteeStar? devotee.devoteeStar:'-'}}
          </td>
          <td>{{devotee.amount? devotee.amount:'-'}}</td>
        </tr>
        <tr>
          <td colspan="2" class="text-md-right font-weight-bold">{{'Total'|translate}} {{'Amount'|translate}}</td>
          <td class="font-weight-bold">{{invoice?.invoiceTotal}}</td>
        </tr>
      </tbody>
    </table>
    <section class="row">
      <div class="col-md-12">
        {{'Pooja'|translate}} {{'Date'|translate}} : &nbsp;
        <textarea rows="2" class="autogrow form-control form-control-sm transition-height"
          autosize> {{invoice?.bookedOn}}</textarea>
      </div>
    </section>
    </div>
  </div>

  <div class="modal-footer d-print-none">
    <app-pagination [collectionSize]="invoiceList?.list?.length" [pageSize]="1" [(page)]="page" [maxSize]="10"
      [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="setPage(page)"></app-pagination>
    <button class="btn btn-secondary btn-sm" type="button" (click)="dismiss()">{{'Cancel'|translate}}</button>
    <button class="btn btn-success btn-sm" appFocusAlways type="button" (click)="print()">Print</button>
  </div>
</ng-container>